import { BRAND } from "../data/media";

type Props = {
  variant?: "header" | "footer" | "lockup" | "full" | "mark" | "dark";
  className?: string;
};

/**
 * Interim EcoEng.net monoline wordmark (white for navy UI, dark for light UI).
 * High-res PNG with retina srcset.
 */
export function BrandLogo({ variant = "header", className = "" }: Props) {
  if (variant === "mark") {
    return (
      <img
        src={BRAND.favicon}
        alt=""
        className={`brand-logo brand-logo-mark ${className}`.trim()}
        width={40}
        height={40}
        decoding="async"
      />
    );
  }

  if (variant === "dark") {
    return (
      <img
        src={BRAND.logoDark}
        alt={BRAND.alt}
        className={`brand-logo brand-logo-dark ${className}`.trim()}
        width={280}
        height={65}
        decoding="async"
      />
    );
  }

  const sizeClass =
    variant === "footer"
      ? "brand-logo-footer"
      : variant === "lockup"
        ? "brand-logo-lockup"
        : variant === "full"
          ? "brand-logo-full"
          : "brand-logo-header";

  const dims =
    variant === "full"
      ? { w: 360, h: 84 }
      : variant === "footer" || variant === "lockup"
        ? { w: 260, h: 60 }
        : { w: 220, h: 52 };

  return (
    <img
      src={BRAND.logoHeader2x}
      srcSet={`${BRAND.logoHeader} 1x, ${BRAND.logoHeader2x} 2x, ${BRAND.logoHeader4x} 3x`}
      alt={BRAND.alt}
      className={`brand-logo ${sizeClass} ${className}`.trim()}
      width={dims.w}
      height={dims.h}
      decoding="async"
    />
  );
}
